let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("967wm")).then(() => parcelRequire('jFH1h'));